import {
  GET_LETTER_ORDERS_ADDRESSES_REQUEST,
  GET_LETTER_ORDERS_ADDRESSES_SUCCESS,
  GET_LETTER_ORDERS_ADDRESSES_FAILURE,
  LOG_OUT_SUCCESS,
} from "../../constants/ActionTypes";
import * as errMessages from "../../constants/ErrorMessages";
import { formatErrorMessage } from "../../utils/utils";

const { OrderedMap } = require("immutable");

const initialState = {
  shortMessage: "",
  message: "",
  errorMessage: "",
  letterOrderAddresses: OrderedMap({}),
  pageInfo: null,
  isLoadingAddresses: false,
};

export default (state = initialState, action) => {
  state = {
    ...state,
    shortMessage: "",
    successMessage: "",
    errorMessage: "",
  };

  let list;

  switch (action.type) {
    case GET_LETTER_ORDERS_ADDRESSES_REQUEST:
      return {
        ...state,
        isLoadingAddresses: true,
        letterOrderAddresses: action.payload.overwrite
          ? OrderedMap({})
          : state.letterOrderAddresses,
      };
    case GET_LETTER_ORDERS_ADDRESSES_SUCCESS:
      list = OrderedMap({});
      action.payload.addresses.forEach((item) => {
        list = list.set(item.id, item);
      });

      return {
        ...state,
        isLoadingAddresses: false,
        letterOrderAddresses: list,
        pageInfo: action.payload.pageInfo,
      };
    case GET_LETTER_ORDERS_ADDRESSES_FAILURE:
      return {
        ...state,
        isLoadingAddresses: false,
        errorMessage: formatErrorMessage(
          action.payload.error,
          errMessages.ERR_GET_FAILURE
        ),
      };
    case LOG_OUT_SUCCESS:
      return initialState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/letterOrderDetail.js